export default __webpack_public_path__ + "static/media/about_us_img2.ca897885.png";